import { EvaluationReport } from "@/schema/console/evaluation-reports/EvaluationReport";
import CollapsibleSubcategory from "@/src/console/(auth)/_components/EvaluationReport/AssessmentDetailCard/CollapsibleSubCategory";
import EvaluationCard from "@/src/console/(auth)/_components/EvaluationReport/EvaluationCard";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

function AssessmentDetailCard() {
  const { t } = useTranslation();
  const { control } = useFormContext<EvaluationReport>();
  const { fields } = useFieldArray({
    control,
    name: "result_index.main_category_results",
    keyName: "key",
  });

  return (
    <EvaluationCard cardTitle={t("assessment-details")}>
      {fields.map((field, index) => (
        <CollapsibleSubcategory key={field.key} index={index} />
      ))}
    </EvaluationCard>
  );
}

export default AssessmentDetailCard;
